const state = () => ({
  adminSharedMimkId: '',
  segmentsList: [],
  isMilitaryTime: null,
  user: {
    id: '',
    name: '',
    role: '',
    full_name: '',
    mimkAward: {},
  },
  mimkList: [],
  mimkListLoaded: false,
  m1List: [],
  m1ListLoaded: false,
  lang: '',
  segment: '',
  segmentM1Distribution: false
})

const getters = {
  getUserSegmentId: (state) => state.segment ? state.segment.id : null,
}

const mutations = {
  setMilitaryTime(state, payload) {
    state.isMilitaryTime = payload
  },
  setUserName(state, payload) {
    state.user.name = payload
  },
  setSegmentsList(state, payload) {
    state.segmentsList = payload
  },
  setAdminSharedMimkId(state, payload) {
    state.adminSharedMimkId = payload
  },
  setUserId(state, payload) {
    state.user.id = payload
  },
  setUserRole(state, payload) {
    state.user.role = payload
  },
  setMimkList(state, payload) {
    state.mimkList = []
    payload.forEach(element => {
      state.mimkList.push({
        id: element.mimk_id,
        label: `${element.full_name}`,
        rating: element.rating,
        status: element.status,
        active: false
      })
    })
    state.mimkListLoaded = true
  },
  setM1List(state, payload) {
    state.m1List = []
    payload.forEach(element => {
      state.m1List.push({
        id: element.m1_id,
        label: `${element.full_name}`,
        rating: element.rating,
        status: element.status,
        active: false
      })
    })
    state.m1ListLoaded = true
  },
  setFullName(state, payload) {
    state.user.full_name = payload
  },
  setLang(state, payload) {
    state.lang = payload
  },
  setSegment(state, payload) {
    state.segment = payload
  },
  setM1Distribution(state, payload) {
    state.segmentM1Distribution = payload
  },
  setMimkAward(state, payload) {
    state.user.mimkAward = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
